import { SuccessIcon } from '@p2p/assets/svg';
import { Button, Typography } from '@p2p/components';
import { MainContainer, useTimer } from '@p2p/entities/payment';
import { usePaymentTemplate } from '@p2p/entities/templates';
import classNames from 'classnames';
import { useCallback, useEffect } from 'react';

import { TransferHead } from '../Payment/components/TransferHead';
import styles from './TransferCanceled.module.scss';
import { TransferCanceledProps } from './TransferCanceled.types';

const COUNT_SECONDS = 5;

export const TransferCanceled = ({ order }: TransferCanceledProps) => {
  const { setIsShowSteps } = usePaymentTemplate();
  const handleFailed = useCallback(() => {
    window.location.replace(order?.merchant_failed_page);
  }, [order?.merchant_failed_page]);
  const { second, locateWordSecond } = useTimer({ time: COUNT_SECONDS, onTimeout: handleFailed });

  const themeName: string = order?.payment_form;

  useEffect(() => {
    setIsShowSteps(false);
    return () => {
      setIsShowSteps(true);
    };
  }, [setIsShowSteps]);

  return (
    <MainContainer className={classNames(styles.transfer_dialog, styles.transfer_dialog_wide)}>
      <TransferHead id={order.id} order={order} status={themeName} />
      <div className={styles.transfer_dialog__body}>
        <div className={styles.transfer_dialog__icon_wr}>
          <SuccessIcon className={styles.transfer_dialog__icon} />
        </div>
        <Typography variant="h1" color="heading" className={styles.transfer_dialog__title}>
          Платеж успешно отменен!
        </Typography>
        <Typography variant="text-l-medium" className={styles.transfer_dialog__description}>
          Мы перенаправим вас на сайт через {second} {locateWordSecond}
        </Typography>
      </div>
      <Button onClick={handleFailed}>Вернуться на сайт</Button>
    </MainContainer>
  );
};
